import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import {
  PenggunaSekolahDtReqModel,
  PenggunaSekolahDtResModel,
} from "../../../_model/pengguna-info.model";
import { PenggunaInfoService } from "../../../_services/pengguna-info.service";
import { CursorError } from "@angular/compiler/src/ml_parser/lexer";

@Component({
  selector: "app-sekolah-list-batas-pengajuan",
  templateUrl: "./sekolah-list-batas-pengajuan.component.html",
  styleUrls: ["./sekolah-list-batas-pengajuan.component.scss"],
})
export class SekolahListBatasPengajuanComponent
  implements OnInit, AfterViewInit
{
  sumberDana = "BOS"; // BOS or BOP
  redirectUrl: any[] = ["/"];
  idOpd: number;
  idOpdPengguna: string;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  formSearch: FormGroup;
  role: string;
  currentUser: any;
  pengguna: any;
  listPengguna: any = [];

  constructor(
    private _formBuilder: FormBuilder,
    private _service: PenggunaInfoService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._activatedRoute.params.subscribe((params) => {
      const sumberDana = params["sumberDana"];
      this.sumberDana = sumberDana;

      const idOpd = params["idOpd"];
      this.idOpd = idOpd;
    });
    this._activatedRoute.queryParams.subscribe((params) => {
      const paramRedirectUrl: string = params["redirectUrl"];
      console.log(paramRedirectUrl);
      if (paramRedirectUrl != undefined) {
        let splitUrl: any[] = paramRedirectUrl.split("<slash>");
        this.redirectUrl = this.redirectUrl.concat(splitUrl);
      } else {
        this.redirectUrl.push("landingpage");
      }
    });
  }

  ngOnInit() {
    this.getPengguna();
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.role = this.currentUser.authorities[0];
    this.initDataTables();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  refresh(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  getPengguna() {
    this._service.findInfo().subscribe((response) => {
      console.log(response.body, "Check Sekolah");
      if (response.status === 200) {
        this.listPengguna = response.body;
        this.idOpdPengguna = this.listPengguna.idOpd;
        console.log(this.idOpdPengguna);
      }
    });
  }

  initDataTables() {
    this.formSearch = this._formBuilder.group({
      nrk: this._formBuilder.control(this.idOpd),
      kodeNamaOpd: this._formBuilder.control(null),
      kodeNama: this._formBuilder.control(null),
      npsn: this._formBuilder.control(null),
      nama: this._formBuilder.control(null),
      idOpd: this._formBuilder.control(null),
    });
    this.dtOptions = {
      lengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, "All"],
      ],
      pagingType: "full_numbers",
      serverSide: true,
      searching: false,
      processing: true,
      autoWidth: false,
      dom: "t<'row'<'col-sm-12'ip><'col-sm-12'l>>",
      order: [1, "desc"],
      ajax: (dataTablesParameters: any, callback) => {
        var search: PenggunaSekolahDtReqModel = this.formSearch.value;
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.role = this.currentUser.authorities[0];
        if (this.role === "SUDIN") {
          search.idOpd = this.currentUser.pengguna.idOpd;
        }
        console.log("search", search);
        this._service
          .datatablesSekolah(dataTablesParameters, search, this.sumberDana)
          .subscribe(
            (resp) => {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: resp.data,
              });
            },
            (error) => {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
            },
          );
      },
      columns: [
        {
          width: "50px",
          title: "No",
          data: null,
          orderable: false,
          className: "text-center align-middle",
          render: (data: any, type: any, row: any, meta) => {
            return `<div class="row justify-content-center">
                        ${meta.row + 1}
                    </div>`;
          },
        },
        // { width: '80px', data: 'kodeNamaOpd', title: 'Kode Nama OPD', className: 'align-middle nopadding' },
        {
          width: "80px",
          data: "npsn",
          title: "NPSN",
          className: "align-middle nopadding",
        },
        {
          width: "80px",
          data: "nama",
          title: "Nama",
          className: "align-middle nopadding",
        },
        {
          width: "70px",
          title: "Aksi",
          data: null,
          className: "text-center align-middle",
          render: (data: any, type: any, row: any, meta) => {
            return `<div class="row justify-content-center">
                      <div class="btn-group btn-group-pill" role="group" aria-label="Tombol Aksi">
                        <button id="edit" title="Detail" class="btn btn-outline-dark txt-dark" type="button" style="font-size: 15px">
                          <i class="fa fa-list"></i>
                        </button>
                      </div>
                    </div>`;
          },
        },
      ],
      rowCallback: (
        row: Node,
        data: PenggunaSekolahDtResModel,
        index: number,
      ) => {
        $("#edit", row).click(() => {
          localStorage.setItem("DataSekolah", JSON.stringify(data));
          console.log(this.redirectUrl.concat(data.id));
          this._router.navigate(this.redirectUrl.concat(data.id), {
            state: { fromMenu: true },
          });
        });

        return row;
      },
    };
  }
}
